import { render, staticRenderFns } from "./LogTabDetails.vue?vue&type=template&id=11edc758&scoped=true&"
import script from "./LogTabDetails.vue?vue&type=script&lang=js&"
export * from "./LogTabDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11edc758",
  null
  
)

export default component.exports